export default function MMAMembership() {
    return (
<div>
 <h4>Members</h4>
                <hr/>
                <p>
                  <b>Roy Snare</b>&nbsp;<i>Treasurer</i>
                  <br/>
                  Appointed Yearly
                </p>
                <p>
                  <b>Daniel Murphy</b>
                  <br/>
                  Term Expires: January 2027
                </p>
                <p>
                  <b>Jane Burger</b>&nbsp;<i>Chairperson</i>
                  <br/>
                  Term Expires: January 2028
                </p>
                <p>
                  <b>Helen Hlahol</b>&nbsp;<i>Secretary</i>
                  <br/>
                  Term Expires: January 2029
                </p>
                <p>
                  <b>Matt Wiedenhaefer</b>
                  <br/>
                  Term Expires: January 2030
                </p>
                 <p>
                  <b>William A. Foote, III</b>
                  <br/>
                  Term Expires: January 2031
                </p>



</div>)}